<template>
    <div>Cari</div>
</template>

<script>
    export default {
        name: "cari"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sim/_/cari.vue